import { Component, Input } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
    template: '',
})
export abstract class FormField {
    @Input() form: FormGroup;
    @Input() readonlyField: boolean = false;
    @Input() fieldName: string;
    @Input() fieldControl: FormControl;
    @Input() fieldLabel: string;
    @Input() fieldDescription: string;
    @Input() placeholder: string = 'Inserisci';
    @Input() warnings: string[];
    @Input() disabled: string;
}
